import AuthWrapperRegisterNew from '~/sections/auth/AuthWrapperRegisterNew';
import AuthRegisterCognitoNew from '~/sections/auth/auth-forms/AuthRegisterCognitoNew';

/**
 * Route component for /register/email.
 *
 * Renders the email registration form. This route is only navigated to
 * when social login is enabled, via the "continue with email" option on /register.
 *
 * `@example`
 * <EmailRegistrationRoute />
 *
 * `@see` SocialLandingRoute
 */
const EmailRegistrationRoute = () => {
  return (
    <AuthWrapperRegisterNew>
      <AuthRegisterCognitoNew />
    </AuthWrapperRegisterNew>
  );
};

export default EmailRegistrationRoute;
